
import NavItem from './components/navItem/index.jsx'
import NavItemCopy from './components/navItemCopy/index.jsx'
import TopImage from './components/topImage/index.jsx'
import BasicsImage from './components/basicsImage/index.jsx'
import BasicsImageCopy from './components/basicsImage/copy.jsx'
import TopImageSide from './components/topImage/side.jsx'
import Suspension from './components/suspension/index.jsx'
import SuspensionSide from './components/suspension/side.jsx'
import TopRotation from './components/topRotation/index.jsx'
import TopRotationSide from './components/topRotation/side.jsx'
import TopVideo from './components/topVideo/index.jsx'
import TopVideSide from './components/topVideo/side.jsx'
import BasicsImageSide from './components/basicsImage/side.jsx'
import BasicsText from './components/basicsText/index.jsx'
import BasicsTextSide from './components/basicsText/side.jsx'
import ConversionOfficial from './components/conversionOfficial/index.jsx'
import ConversionOfficialSide from './components/conversionOfficial/side.jsx'
import BasicsTextCopy from './components/basicsText/copy.jsx'
import ConversionOfficialCopy from './components/conversionOfficial/copy.jsx'
import React from 'react'
console.log(React)

export const datas = [{
  title: '顶部组件',
  data: [{
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: TopImage,
    contentCopyComp: '',
    sideComp: TopImageSide,
    text: '图片',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fill-rule='evenodd'><path d='M19.5 6A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6h11zm-2.657 8.156a1 1 0 00-1.347.006l-4.22 3.881a.5.5 0 01-.643.03l-2.731-2.087a.25.25 0 00-.402.199V19.5a1 1 0 001 1h11a1 1 0 001-1v-1.82a.5.5 0 00-.165-.371zM11 9.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z' fill='url(#a)' fill-rule='nonzero'></path><path d='M5.25 1a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5z' fill='#C7C7C7'></path></g></svg>,
    ifon: {
      ad_location: 'sns',
      outer_style: 0,
      imgeIfon: {
        sns: {
          regularAdvertising: {},
          cardAdvertising: {}
        },
        gzh: {}
      }
    },
    type: '',
    name: 'top_image_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: TopRotation,
    contentCopyComp: '',
    sideComp: TopRotationSide,
    text: '轮播图',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stopColor='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fillRule='evenodd'><path d='M19.5 6A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6h11zm-3.905 8.082l-.099.08-4.22 3.881a.5.5 0 01-.567.077l-.076-.048-2.731-2.086a.25.25 0 00-.395.142l-.007.057V19.5a1 1 0 00.883.993l.117.007h11a1 1 0 00.993-.883l.007-.117v-1.82a.5.5 0 00-.107-.31l-.058-.061-3.492-3.153a1 1 0 00-1.248-.074zM24 9a2 2 0 012 2v6a2 2 0 01-2 2h-1v-1.5h1a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-1V9h1zM5 9v1.5H4a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h1V19H4a2 2 0 01-2-2v-6a2 2 0 012-2h1zm6 .5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z' fill='url(#a)' fillRule='nonzero'></path><path d='M5.25 1a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5z' fill='#C7C7C7'></path></g></svg>,
    ifon: {
      image_id_list: [{}, {}, {}],
      currentIndex: 0
    },
    type: '',
    name: 'top_carousel_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: TopVideo,
    contentCopyComp: '',
    sideComp: TopVideSide,
    text: '视频',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stopColor='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fillRule='evenodd'><path d='M16.5 8A1.5 1.5 0 0118 9.5v2.25l4.2-3.15a.5.5 0 01.8.4v10a.5.5 0 01-.8.4L18 16.25v2.25a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 015 18.5v-9A1.5 1.5 0 016.5 8h10z' fill='url(#a)' fillRule='nonzero'></path><path d='M5.25 1a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5z' fill='#C7C7C7'></path></g></svg>,
    ifon: {
      videoIfon: {
        sns: {
          regularAdvertising: {},
          cardAdvertising: {}
        },
        gzh: {}
      },
      ad_location: 'sns',
      outer_style: 0,
      used_for_outer: ''
    },
    type: '',
    name: 'top_video_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '引用外层素材',
    icon: <svg fill='none' viewBox='0 0 28 28' width='28' height='28'><path fill='url(#paint0_linear)' fillRule='evenodd' d='M12.5 15.25c0-1.2426 1.0074-2.25 2.25-2.25h8.5c1.2426 0 2.25 1.0074 2.25 2.25v7c0 1.2426-1.0074 2.25-2.25 2.25h-8.5c-1.2426 0-2.25-1.0074-2.25-2.25v-7zm2.25-.75a.75.75 0 00-.75.75v7a.75.75 0 00.75.75h8.5a.75.75 0 00.75-.75v-7a.75.75 0 00-.75-.75h-8.5z' clipRule='evenodd' opacity='.4'></path><path fill='#C7C7C7' fill-rule='evenodd' d='M2 1.75A.75.75 0 012.75 1h2.5a.75.75 0 010 1.5h-2.5A.75.75 0 012 1.75zm5 0A.75.75 0 017.75 1h2.5a.75.75 0 010 1.5h-2.5A.75.75 0 017 1.75zM12.75 1a.75.75 0 000 1.5h2.5a.75.75 0 000-1.5h-2.5zm4.25.75a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5h-2.5a.75.75 0 01-.75-.75zM22.75 1a.75.75 0 000 1.5h2.5a.75.75 0 000-1.5h-2.5z' clipRule='evenodd'></path><path fill='url(#paint1_linear)' d='M3 8.5C3 7.6716 3.6716 7 4.5 7h11c.8284 0 1.5.6716 1.5 1.5v7c0 .8284-.6716 1.5-1.5 1.5h-11c-.8284 0-1.5-.6716-1.5-1.5v-7z'></path><path fill='url(#paint2_linear)' fillRule='evenodd' d='M5.75 19.25a.75.75 0 00-1.5 0c0 .62.1798 1.5333.7413 2.3132C5.5804 22.3814 6.5556 23 8 23v1.3801c0 .0882.0276.1736.0793.244.1302.1797.3776.2159.552.0817l2.8931-2.2367a.4019.4019 0 00.0789-.0817c.131-.1798.0955-.4348-.0789-.5694l-2.8931-2.2367a.3862.3862 0 00-.2368-.0813c-.2178 0-.3945.1822-.3945.4067V21.5c-.9556 0-1.4804-.3814-1.7914-.8132C5.8702 20.2167 5.75 19.63 5.75 19.25z' clipRule='evenodd'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'top_layer_comp'
  }]
}, {
  title: '基础组件',
  data: [{
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: BasicsImage,
    contentCopyComp: BasicsImageCopy,
    sideComp: BasicsImageSide,
    text: '图片',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M19.5 6A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6h11zm-2.657 8.156a1 1 0 00-1.347.006l-4.22 3.881a.5.5 0 01-.643.03l-2.731-2.087a.25.25 0 00-.402.199V19.5a1 1 0 001 1h11a1 1 0 001-1v-1.82a.5.5 0 00-.165-.371zM11 9.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z' fill='url(#a)' fillRule='nonzero'></path></svg>,
    ifon: {
      imageIfon: {},
      padding_top: 0,
      padding_bottom: 0
    },
    type: '',
    name: 'basics_image_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '轮播图',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stopColor='#999' offset='0%'></stop><stop stopColor='#737373' offset='100%'></stop></linearGradient></defs><path d='M19.5 6A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6h11zm-3.905 8.082l-.099.08-4.22 3.881a.5.5 0 01-.567.077l-.076-.048-2.731-2.086a.25.25 0 00-.395.142l-.007.057V19.5a1 1 0 00.883.993l.117.007h11a1 1 0 00.993-.883l.007-.117v-1.82a.5.5 0 00-.107-.31l-.058-.061-3.492-3.153a1 1 0 00-1.248-.074zM24 9a2 2 0 012 2v6a2 2 0 01-2 2h-1v-1.5h1a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-1V9h1zM5 9v1.5H4a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h1V19H4a2 2 0 01-2-2v-6a2 2 0 012-2h1zm6 .5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z' fill='url(#a)' fillRule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_carousel_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '视频',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='bvideo'><stop stopColor='#999' offset='0%'></stop><stop stopColor='#737373' offset='100%'></stop></linearGradient><path d='M16.5 8A1.5 1.5 0 0118 9.5v2.25l4.2-3.15a.5.5 0 01.8.4v10a.5.5 0 01-.8.4L18 16.25v2.25a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 015 18.5v-9A1.5 1.5 0 016.5 8h10z' id='avideo'></path></defs><use fillRule='nonzero' ></use></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_video_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '180°全景图',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stopColor='#737373' offset='100%'></stop></linearGradient></defs><path d='M3.87 15.507a.807.807 0 01-.26 1.09c-.738.46-1.071.929-1.071 1.39 0 1.448 3.226 2.748 8.304 3.16v-1.569c0-.196.136-.36.316-.398l.08-.008.083.009a.386.386 0 01.105.04l.048.032 2.893 2.237.059.055a.417.417 0 01.061.443l-.041.07-.036.045-.043.038-2.893 2.236-.068.043a.386.386 0 01-.43-.064l-.054-.06-.044-.075a.412.412 0 01-.031-.111l-.004-.058-.001-1.314C4.866 22.284 1 20.692 1 17.987c0-1.101.658-2.026 1.813-2.747a.756.756 0 011.057.267zm21.216-.273c1.22.736 1.914 1.682 1.914 2.815 0 2.632-3.618 4.202-9.377 4.759a.776.776 0 01-.838-.716.787.787 0 01.694-.863c4.964-.48 7.982-1.79 7.982-3.18 0-.479-.358-.967-1.152-1.447a.807.807 0 01-.275-1.085.757.757 0 011.052-.283zM12.38 6.7c1.503 0 2.46 1.01 2.46 2.593v.215c0 .76-.3 1.45-.82 1.92.62.437.98 1.197.98 2.075v.321c0 1.703-1.01 2.755-2.62 2.755-1.611 0-2.62-1.052-2.62-2.755v-.321c0-.874.357-1.635.967-2.074-.507-.46-.807-1.162-.807-1.921v-.215c0-1.582.956-2.593 2.46-2.593zm6.603.153c1.693 0 2.748 1.123 2.748 2.918v3.882c0 1.78-1.054 2.89-2.748 2.89-1.672 0-2.733-1.118-2.733-2.89V9.771c0-1.787 1.062-2.918 2.733-2.918zM7.725 6.847c.322 0 .583.261.583.583v8.21a.75.75 0 11-1.5 0V8.897l-.856.604a.35.35 0 01-.552-.286v-.74a.6.6 0 01.246-.484l1.274-.93a1.1 1.1 0 01.65-.213h.155zm4.655 5.261c-.778 0-1.233.483-1.233 1.395v.321c0 .912.455 1.381 1.233 1.381.777 0 1.233-.47 1.233-1.38v-.322c0-.912-.456-1.395-1.233-1.395zm6.603-3.799c-.793 0-1.232.514-1.232 1.462v3.882c0 .923.442 1.433 1.232 1.433.803 0 1.247-.508 1.247-1.433V9.771c0-.95-.441-1.462-1.247-1.462zM12.38 8.06c-.684 0-1.086.43-1.086 1.274v.2c0 .885.402 1.355 1.086 1.355.683 0 1.086-.47 1.086-1.354v-.201c0-.845-.403-1.274-1.086-1.274zm12.25-1.635c1.164 0 1.944.796 1.944 1.985 0 1.188-.78 1.984-1.943 1.984-1.176 0-1.958-.793-1.958-1.984 0-1.191.782-1.985 1.958-1.985zm0 1.083c-.516 0-.845.351-.845.902 0 .55.33.901.846.901.503 0 .83-.353.83-.901 0-.549-.327-.902-.83-.902z' fill='url(#a)' fillRule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_panorama_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: BasicsText,
    contentCopyComp: BasicsTextCopy,
    sideComp: BasicsTextSide,
    text: '文本',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='canvas_gradient_common'><stop stop-color='#999' offset='0%'></stop><stop stopColor='#737373' offset='100%'></stop></linearGradient></defs><path d='M8.5 6h11A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6zm1 3.5V11h9V9.5h-9zM12 17v1.5h4V17h-4zm-2.5-6v1.5h.75l.375-1.5H9.5zm9 0h-1.125l.375 1.5h.75V11zm-5.25 0v6h1.5v-6h-1.5z' fill='url(#a)' fillRule='nonzero'></path></svg>,
    ifon: {
      text: '',
      padding_top: 22,
      padding_bottom: 22,
      font_size: 15,
      font_color: '#333333',
      text_alignment: 0,
      font_style: 0
    },
    type: '',
    name: 'basics_text_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '商家名片',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stopColor='#737373' offset='100%'></stop></linearGradient></defs><path d='M20.5 7A2.5 2.5 0 0123 9.5v8a2.5 2.5 0 01-2.5 2.5h-13A2.5 2.5 0 015 17.5v-8A2.5 2.5 0 017.5 7h13zm-.75 6.25h-5.5a.25.25 0 00-.25.25v1c0 .138.112.25.25.25h5.5a.25.25 0 00.25-.25v-1a.25.25 0 00-.25-.25zM9.5 10a2 2 0 100 4 2 2 0 000-4zm10.25-.5h-5.5a.25.25 0 00-.25.25v1c0 .138.112.25.25.25h5.5a.25.25 0 00.25-.25v-1a.25.25 0 00-.25-.25z' fill='url(#a)' fillRule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_card_comp'
  }]
}, {
  title: '转化按钮',
  data: [{
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '跳转链接',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stopColor='#999' offset='0%'></stop><stop stopColor='#737373' offset='100%'></stop></linearGradient></defs><path d='M21 7a3 3 0 013 3v8a3 3 0 01-3 3H7a3 3 0 01-3-3v-8a3 3 0 013-3h14zm-8.326 6.225a1.273 1.273 0 00-1.8 0l-1.501 1.5a1.273 1.273 0 000 1.801l2.1 2.101a1.273 1.273 0 001.802 0l1.5-1.5a1.273 1.273 0 000-1.801L12.3 17.802 10.2 15.7zm2.734-.49a.591.591 0 00-.836 0l-1.915 1.915a.591.591 0 10.836.837l1.915-1.916a.591.591 0 000-.836zm1.118-3.362a1.273 1.273 0 00-1.8 0l-1.501 1.5a1.273 1.273 0 000 1.801l2.476-2.476 2.1 2.101-2.475 2.476a1.273 1.273 0 001.8 0l1.501-1.5a1.273 1.273 0 000-1.801z' fill='url(#a)' fillRule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_convert_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '下载应用',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M21 7a3 3 0 013 3v8a3 3 0 01-3 3H7a3 3 0 01-3-3v-8a3 3 0 013-3h14zm-3.5 10.5h-7a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V18a.5.5 0 00-.5-.5zM14.529 9h-1.005a.244.244 0 00-.247.254V13h-1.994c-.28 0-.367.184-.195.4l2.627 3.208c.172.216.451.216.623 0l2.627-3.208c.172-.217.081-.4-.194-.4h-1.994V9.254A.255.255 0 0014.529 9z' fill='url(#a)' fillRule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_application_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '进入小程序',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M21 7a3 3 0 013 3v8a3 3 0 01-3 3H7a3 3 0 01-3-3v-8a3 3 0 013-3h14zm-4.857 2a2.857 2.857 0 00-2.857 2.857v4.286a1.429 1.429 0 11-1.429-1.429v-1.428a2.857 2.857 0 102.857 2.857v-4.286a1.429 1.429 0 111.429 1.429v1.428a2.857 2.857 0 100-5.714z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_applet_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '进入小游戏',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M21 7a3 3 0 013 3v8a3 3 0 01-3 3H7a3 3 0 01-3-3v-8a3 3 0 013-3h14zm-6.257 3.96a3.677 3.677 0 00-3.081-.463A3.816 3.816 0 009.29 12.58c-.824 2.254.163 4.784 2.27 5.818a3.663 3.663 0 003.021.46 3.795 3.795 0 002.358-2.004c.88-2.255-.079-4.83-2.196-5.894zm-.224.895c.759 0 1.374.635 1.374 1.42 0 .783-.615 1.42-1.374 1.42-.76 0-1.375-.637-1.375-1.42 0-.785.616-1.42 1.375-1.42zM18.627 9c-.656 0-1.22.477-1.35 1.141a1.43 1.43 0 00.821 1.59 1.35 1.35 0 001.67-.522 1.455 1.455 0 00-.17-1.792 1.367 1.367 0 00-.97-.417z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_games_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '枫页推广页',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M21.5 7c1.38 0 2.5 1.343 2.5 3v8c0 1.657-1.12 3-2.5 3h-15C5.12 21 4 19.657 4 18v-8c0-1.657 1.12-3 2.5-3h15zM13 15h-1.75A1.75 1.75 0 1013 16.75V15zm3.75 0H15v1.75A1.75 1.75 0 1016.75 15zm-5.5-5.5a1.75 1.75 0 000 3.5H13v-1.75a1.75 1.75 0 00-1.75-1.75zm5.5 0A1.75 1.75 0 0015 11.25V13h1.75a1.75 1.75 0 000-3.5z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_page_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '添加商家微信',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fill-rule='evenodd'><path d='M6.5 7h15c1.38 0 2.5 1.343 2.5 3v8c0 1.657-1.12 3-2.5 3h-15C5.12 21 4 19.657 4 18v-8c0-1.657 1.12-3 2.5-3z' fill='url(#a)' fill-rule='nonzero'></path><path d='M14 9.5c2.485 0 4.5 1.833 4.5 4.093s-2.015 4.093-4.5 4.093c-.496 0-.974-.073-1.42-.208-.002.01-.434.24-1.296.69a.367.367 0 01-.533-.378l.025-.178c.1-.685.151-1.026.155-1.026-.88-.747-1.431-1.811-1.431-2.993 0-2.26 2.015-4.093 4.5-4.093zM11.75 13a.75.75 0 100 1.5.75.75 0 000-1.5zM14 13a.75.75 0 100 1.5.75.75 0 000-1.5zm2.25 0a.75.75 0 100 1.5.75.75 0 000-1.5z' fill='#FFF'></path></g></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_wechatMerchants_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '关注公众号视频',
    icon: <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M7 7C5.34315 7 4 8.34315 4 10V18C4 19.6569 5.34315 21 7 21H21C22.6569 21 24 19.6569 24 18V10C24 8.34315 22.6569 7 21 7H7ZM12.5853 16.38C12.9149 15.9005 13.1879 15.4084 13.345 15.1092C13.1766 14.8249 12.8884 14.3398 12.5538 13.7843C11.0673 11.3165 10.2811 10.6385 9.96474 10.4523C9.88187 10.4035 9.77564 10.44 9.73884 10.5289C9.50531 11.0933 9.65499 12.7307 10.1029 14.5108C10.5228 16.18 10.9774 17.1219 11.2147 17.4796C11.2742 17.5694 11.3909 17.6003 11.486 17.5497C11.6953 17.4381 12.0593 17.1451 12.5853 16.38ZM16.7878 17.457C17.0271 17.0844 17.4722 16.147 17.8837 14.5108C18.3316 12.7307 18.4813 11.0933 18.248 10.529L18.247 10.5265C18.2092 10.4357 18.1092 10.4009 18.0244 10.4506C17.7108 10.6343 16.924 11.3087 15.4328 13.7843C15.0971 14.3417 14.808 14.8281 14.64 15.112C15.2758 16.3511 16.0074 17.2533 16.4523 17.53C16.5659 17.6006 16.7154 17.5695 16.7878 17.457ZM18.2745 9.25307C18.5333 9.27261 19.0092 9.408 19.2938 10.0964C19.6865 11.0459 19.3914 12.9033 19.1805 13.926C18.862 15.4704 18.3492 17.0086 17.8739 17.8447C17.5578 18.4007 17.2419 18.6844 16.8798 18.7372C16.8216 18.7457 16.7623 18.75 16.7037 18.75C15.6333 18.75 14.6144 17.3526 13.9932 16.2877C13.3719 17.3526 12.3529 18.75 11.2829 18.75C11.2242 18.75 11.165 18.7457 11.107 18.7372C10.7447 18.6844 10.4287 18.4007 10.1126 17.8447C9.63738 17.0084 9.12455 15.4704 8.80607 13.926C8.59513 12.9033 8.30002 11.0459 8.69274 10.0964C8.97749 9.408 9.45341 9.27261 9.71195 9.25307C10.672 9.18177 11.8138 10.3621 13.5234 13.2003C13.6963 13.4875 13.8558 13.754 13.9933 13.9846C14.1315 13.7529 14.2912 13.4857 14.4632 13.2003C16.1724 10.3629 17.3093 9.18134 18.2745 9.25307Z' fill='url(#paint0_linear)'></path><defs><linearGradient id='paint0_linear' x1='23.4125' y1='20.959' x2='23.4125' y2='7.7816' gradientUnits='userSpaceOnUse'><stop stop-color='#999999'></stop><stop offset='1' stop-color='#737373'></stop></linearGradient></defs></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_officialVideo_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '在线咨询',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fill-rule='evenodd'><path d='M0 0h28v28H0z'></path><path d='M5 7h18a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3z' fill='url(#a)' fill-rule='nonzero'></path><path d='M15.467 18.255A1 1 0 0 1 14.5 19h-1a1 1 0 1 1 0-2h1c.274 0 .522.11.702.288a3.511 3.511 0 0 0 1.8-1.487.761.761 0 0 1-.002-.051V13.5a3 3 0 1 0-6 0v2.25a.75.75 0 0 1-.75.75h-.5c-.69 0-1.25-.56-1.25-1.25V15a1.5 1.5 0 0 1 1-1.415V13.5a4.5 4.5 0 0 1 9 0v.085a1.5 1.5 0 0 1 1 1.415v.25c0 .69-.56 1.25-1.25 1.25h-.508a4.512 4.512 0 0 1-2.275 1.755z' fill='#FFF'></path></g></svg>,
    ifon: {

    },
    type: '',
    name: 'basics_consulting_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: ConversionOfficial,
    contentCopyComp: ConversionOfficialCopy,
    sideComp: ConversionOfficialSide,
    text: '关注公众号',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M21 7a3 3 0 013 3v8a3 3 0 01-3 3H7a3 3 0 01-3-3v-8a3 3 0 013-3h14zm-9.603 8.08h-1.256C7.981 15.08 7 16.84 7 18.3v.194c0 .28.216.506.492.506h6.516a.49.49 0 00.492-.5v-.2c0-1.46-1.5-3.3-3.103-3.22zM18.242 10h-.484a.496.496 0 00-.508.491v1.758l-1.759.001c-.234 0-.44.18-.483.417l-.008.09v.485c0 .287.22.508.491.508l1.759-.001v1.76c0 .234.18.44.417.483l.09.008h.485c.287 0 .508-.22.508-.491v-1.76l1.759.001c.234 0 .44-.18.483-.417l.008-.09v-.485a.496.496 0 00-.491-.508l-1.759-.001v-1.758c0-.234-.18-.44-.417-.483l-.09-.008zm-7.414 0a2 2 0 00-2.005 1.996 2 2 0 002.005 1.996 2 2 0 002.005-1.996A2 2 0 0010.828 10z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {
      title: '关注公众号',
      font_color: '#ffffff',
      bg_color: '#07C160',
      border_color: '#ffffff',
      padding_top: 22,
      padding_bottom: 22,
      isFollow: false,
      isIcon: false,
      text_alignment: 0,
      url: '',
      protocolType: 0
    },
    type: '',
    name: 'basics_OfficialAccount_comp'
  }]
}, {
  title: '营销组件',
  data: [{
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '表单',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fill-rule='nonzero'><rect fill='url(#a)' x='6' y='6' width='16' height='16' rx='1.5'></rect><path fill='#FFF' d='M9 9.5h1.5V11H9zM9 13.25h1.5v1.5H9zM9 17h1.5v1.5H9zM12 9.5h7V11h-7zM12 13.25h7v1.5h-7zM12 17h7v1.5h-7z'></path></g></svg>,
    ifon: {

    },
    type: '',
    name: 'marketing_form_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '一键拨号',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M7.5 6h13A1.5 1.5 0 0 1 22 7.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 6 20.5v-13A1.5 1.5 0 0 1 7.5 6zm4.889 2.513c-.275.051-.59.213-.793.348-.574.384-.996.812-1.077 1.436-.122.928.338 3.18 1.242 4.937.903 1.756 2.412 3.33 3.19 3.677.498.223 1.188.006 1.754-.42.259-.196.46-.337.657-.629a.615.615 0 0 0 .132-.47 3.326 3.326 0 0 0-.028-.145s-.055-.338-.395-.797a6.997 6.997 0 0 0-.458-.555c-.283-.304-.543-.523-.543-.523l-.066-.047a.335.335 0 0 0-.411-.02l-.03.02-.081.059c-.166.156-.126.133-.264.269-.147.15-.222.304-.426.551-.206.25-.563.188-.71.062-.402-.345-.785-.86-1.234-1.734a8.606 8.606 0 0 1-.705-1.959c-.101-.413.222-.708.493-.78.199-.054.396-.09.54-.127.328-.088.436-.147.402-.138a.422.422 0 0 0 .223-.172.545.545 0 0 0 .076-.35l-.045-.231c.004.014-.059-.212-.162-.54a10.38 10.38 0 0 0-.347-.912c-.152-.35-.245-.494-.245-.494s-.1-.152-.087-.128l-.04-.05c-.126-.158-.408-.167-.562-.138z' fill='url(#a)' fill-rule='nonzero'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'marketing_dial_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '图文复合组件',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#8F8F8F' offset='0%'></stop><stop stop-color='#666' offset='100%'></stop></linearGradient><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='b'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fill-rule='nonzero'><rect fill='url(#a)' opacity='.4' x='16' y='7' width='3' height='3' rx='1'></rect><rect fill='url(#a)' opacity='.6' x='11' y='6' width='4' height='4' rx='.75'></rect><path d='M18.375 19.75a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm-7.25 0a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zM8.576 6.5a.5.5 0 01.494.418L9.75 11h10.597a1 1 0 01.99 1.141l-.653 4.571A1.5 1.5 0 0119.199 18h-8.907a1.5 1.5 0 01-1.484-1.277L7.5 8h-2a.5.5 0 01-.5-.5V7a.5.5 0 01.5-.5h3.076z' fill='url(#b)'></path></g></svg>,
    ifon: {

    },
    type: '',
    name: 'marketing_graphic_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: Suspension,
    contentCopyComp: '',
    sideComp: SuspensionSide,
    text: '悬浮组件',
    icon: <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5.5 8.5C3.84315 8.5 2.5 9.84315 2.5 11.5V16.5C2.5 18.1569 3.84315 19.5 5.5 19.5H22.5C24.1569 19.5 25.5 18.1569 25.5 16.5V11.5C25.5 9.84315 24.1569 8.5 22.5 8.5H5.5ZM5.5 12.5H8.5V15.5H5.5V12.5ZM17.5 14.5V13.5H22.5V14.5H17.5Z' fill='url(#paint0_linear)' stroke='white'></path><defs><linearGradient id='paint0_linear' x1='24.3537' y1='18.9707' x2='24.3537' y2='9.55829' gradientUnits='userSpaceOnUse'><stop stop-color='#999999'></stop><stop offset='1' stop-color='#737373'></stop></linearGradient></defs></svg>,
    ifon: {
      imageIfon: {},
      style_type: 0,
      title: '',
      title_color: '#171717',
      desc: '',
      desc_color: '#4C4C4C',
      appear_type: 0,
      disappear_type: 0,
      forbid_page_list: [1],
      element_type: 'APP_DOWNLOAD',
      type: 9,
      myType: {
        officialAccount: {
          title: '立即预约',
          font_color: '#ffffff',
          bg_color: '#07C160',
          text_alignment: 0,
          isFollow: false
        },
        one_touch_dialing: {
          telephoneType: 0,
          ordinaryTelephone: {
            fixedLine: '',
            mobilePhone: ''
          },
          smartPhone: {

          },
          title: '立即预约',
          font_color: '#ffffff',
          bg_color: '#07C160',
          text_alignment: 0
        }
      }
    },
    type: '',
    name: 'marketing_suspension_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '动态悬浮组件',
    icon: <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5.5 8.5C3.84315 8.5 2.5 9.84315 2.5 11.5V16.5C2.5 18.1569 3.84315 19.5 5.5 19.5H22.5C24.1569 19.5 25.5 18.1569 25.5 16.5V11.5C25.5 9.84315 24.1569 8.5 22.5 8.5H5.5ZM5.5 12.5H8.5V15.5H5.5V12.5ZM17.5 14.5V13.5H22.5V14.5H17.5Z' fill='url(#paint0_linear)' stroke='white'></path><defs><linearGradient id='paint0_linear' x1='24.3537' y1='18.9707' x2='24.3537' y2='9.55829' gradientUnits='userSpaceOnUse'><stop stop-color='#999999'></stop><stop offset='1' stop-color='#737373'></stop></linearGradient></defs></svg>,
    ifon: {

    },
    type: '',
    name: 'marketing_dynamicSuspension_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '商家二维码',
    icon: <svg width='20px' height='28px' viewBox='0 0 20 14'><path fill='url(#a)' d='M21.5 7c1.3807 0 2.5 1.3431 2.5 3v8c0 1.6569-1.1193 3-2.5 3h-15C5.1193 21 4 19.6569 4 18v-8c0-1.6569 1.1193-3 2.5-3h15zM10 15.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 100-1h-1.5V16a.5.5 0 00-.5-.5zm8 0a.5.5 0 00-.5.5v1.5H16a.5.5 0 100 1h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zm.5-2h-9a.5.5 0 100 1h9a.5.5 0 100-1zm-6.5-4h-2a.5.5 0 00-.5.5v2a.5.5 0 101 0v-1.5H12a.5.5 0 100-1zm6 0h-2a.5.5 0 100 1h1.5V12a.5.5 0 101 0v-2a.5.5 0 00-.5-.5z' transform='translate(-4 -7)'></path></svg>,
    ifon: {

    },
    type: '',
    name: 'marketing_QRCode_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '领取红包封面',
    icon: <svg width='28' height='28' viewBox='0 0 28 28'><path fill='url(#redpacket_gradient)' fill-rule='evenodd' d='M9.5 6C8.1193 6 7 7.1193 7 8.5v11C7 20.8807 8.1193 22 9.5 22h9c1.3807 0 2.5-1.1193 2.5-2.5v-11C21 7.1193 19.8807 6 18.5 6h-9zm5.9087 6.5803L19.5 10.8269v1.632l-3.5005 1.5002a1.853 1.853 0 01.0004.0409c0 1.1046-.8954 2-2 2-1.1045 0-2-.8954-2-2 0-.0137.0002-.0273.0005-.041L8.5 12.4589v-1.632l4.0912 1.7534A1.9937 1.9937 0 0113.9999 12c.5495 0 1.0473.2216 1.4088.5803z' clip-rule='evenodd'></path><defs><linearGradient id='redpacket_gradient' x1='20.5887' x2='20.5887' y1='21.9532' y2='6.8933' gradientUnits='userSpaceOnUse'><stop stop-color='#999'></stop><stop offset='1' stop-color='#737373'></stop></linearGradient></defs></svg>,
    ifon: {

    },
    type: '',
    name: 'marketing_cover_comp'
  }, {
    navComp: NavItem,
    navCopyComp: NavItemCopy,
    contentComp: '',
    contentCopyComp: '',
    sideComp: '',
    text: '上滑打开链接',
    icon: <svg width='28' height='28' viewBox='0 0 28 28' fill='none'><path opacity='.6' fill-rule='evenodd' clip-rule='evenodd' d='M7.057 5.316A.75.75 0 0 1 7.5 6v8A.75.75 0 0 1 6 14V7.67l-1.002.89a.75.75 0 0 1-.996-1.12l2.25-2a.75.75 0 0 1 .805-.124z' fill='url(#paint0_linear)'></path><path d='M9.33 19.771l4.72 1.987a6.5 6.5 0 0 0 5.372-.148l2.041-.996a5.071 5.071 0 0 0 2.335-6.78l-1.017-2.088a2.75 2.75 0 0 0-3.678-1.266l-3.91 1.907-2.834-4.364-.42.272.42-.272a1.925 1.925 0 0 0-2.46-.683 1.762 1.762 0 0 0-.811 2.356l3.464 7.102-1.995-.282a1.954 1.954 0 0 0-2.065 1.153 1.59 1.59 0 0 0 .839 2.102z' fill='url(#paint1_linear)' stroke='#fff'></path><path fill='#fff' d='M0 0h28v28H0z'></path><path opacity='.6' fill-rule='evenodd' clip-rule='evenodd' d='M7.22 3.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-.72-.72v6.44a.75.75 0 0 1-1.5 0V5.81l-.72.72a.75.75 0 0 1-1.06-1.06l2-2z' fill='url(#paint2_linear)'></path><path d='M11.962 7.304c.699-.174 1.418.2 1.676.874l2.023 5.27 4.65-1.159a2.25 2.25 0 0 1 2.728 1.64l.562 2.252a4.57 4.57 0 0 1-3.33 5.541l-2.204.55a5.999 5.999 0 0 1-4.879-.897L8.986 18.45a1.09 1.09 0 0 1-.263-1.53 1.454 1.454 0 0 1 1.681-.519l2.778 1.014-2.14-8.58a1.262 1.262 0 0 1 .92-1.53z' fill='url(#paint3_linear)'></path><defs><linearGradient id='paint0_linear' x1='7.39' y1='14.722' x2='7.39' y2='5.78' gradientUnits='userSpaceOnUse'><stop stop-color='#8F8F8F'></stop><stop offset='1' stop-color='#666'></stop></linearGradient><linearGradient id='paint1_linear' x1='18.592' y1='21.406' x2='11.99' y2='7.87' gradientUnits='userSpaceOnUse'><stop stop-color='#999'></stop><stop offset='1' stop-color='#737373'></stop></linearGradient><linearGradient id='paint2_linear' x1='10.338' y1='11.725' x2='10.338' y2='3.725' gradientUnits='userSpaceOnUse'><stop stop-color='#8F8F8F'></stop><stop offset='1' stop-color='#666'></stop></linearGradient><linearGradient id='paint3_linear' x1='17.419' y1='22.385' x2='13.775' y2='7.773' gradientUnits='userSpaceOnUse'><stop stop-color='#999'></stop><stop offset='1' stop-color='#737373'></stop></linearGradient></defs></svg>,
    ifon: {

    },
    type: '',
    name: 'marketing_link_comp'
  }]
}]
